import React, { FC } from 'react'
import ReactDateTimePicker from 'react-datetime-picker'

import './DateTimePicker.scss'

export const DateTimePicker: FC<any> = props => (
  <ReactDateTimePicker className="datetime-picker" calendarClassName="datetime-picker__calendar" disableClock {...props} />
)
